import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'Salesman/All', method: 'GET', body: null, token: token })
}
